const userRouter = [
    {
        path: '/user/selectManager/index',
        name: 'UserSelectManagerIndex',
        component: () => import('@/views/user/selectManager/index.vue'),
        meta: { title: '客户提醒', isQiwei: false },
    },
    {
        path: '/user/selectManager/location',
        name: 'UserSelectManagerLocation',
        component: () => import('@/views/user/selectManager/location.vue'),
        meta: { title: '位置授权', isQiwei: false },
    },
];

export default userRouter;
